import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "widget-chatbot" }
const _hoisted_3 = { class: "widget-chatbot-header" }
const _hoisted_4 = { class: "flex align-items-center" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "font-semibold text-base" }
const _hoisted_7 = {
  class: "widget-chatbot-messages",
  ref: "messagesContainer"
}
const _hoisted_8 = {
  key: 0,
  class: "widget-chatbot-tag"
}
const _hoisted_9 = {
  key: 1,
  class: "text-center my-5"
}
const _hoisted_10 = {
  key: 3,
  class: "widget-chatbot-indication"
}
const _hoisted_11 = { class: "widget-chatbot-send-message" }
const _hoisted_12 = { class: "widget-chatbot-input-set" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("section", _hoisted_1, [
      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "h-20" }, null, -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              src: _ctx.agentAvatar,
              class: "size-2xl rounded-100 mr-3",
              alt: "Agent"
            }, null, 8, _hoisted_5),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.agentName), 1)
          ]),
          _cache[4] || (_cache[4] = _createElementVNode("div", null, [
            _createElementVNode("h2", { class: "font-semibold" }, "Live Tchat")
          ], -1))
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_ctx.selectedTag)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.selectedTag), 1))
            : _createCommentVNode("", true),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("p", _hoisted_9, "Chargement des messages..."))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.messages, (message, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: message.id || index,
                  class: _normalizeClass(['message', message.qui])
                }, _toDisplayString(message.texte), 3))
              }), 128)),
          (_ctx.isAgentTyping)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "loader-dots left" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.agentName) + " est entrain d'ecrire... ", 1)
              ]))
            : _createCommentVNode("", true)
        ], 512),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newMessage) = $event)),
              type: "text",
              class: "widget-chatbot-input",
              placeholder: "Écrire un message...",
              onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.sendMessage && _ctx.sendMessage(...args)), ["enter"]))
            }, null, 544), [
              [_vModelText, _ctx.newMessage]
            ]),
            _createElementVNode("button", {
              class: "btn-ultra grey tips attachment",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.attachFile && _ctx.attachFile(...args)))
            }, [...(_cache[6] || (_cache[6] = [
              _createElementVNode("div", { class: "btn-show" }, [
                _createElementVNode("img", {
                  src: "/public/icons/icon-attachment.svg",
                  class: "btn-icon",
                  alt: ""
                })
              ], -1),
              _createElementVNode("div", { class: "btn-loading" }, [
                _createElementVNode("div", { class: "loader-dots" })
              ], -1)
            ]))])
          ]),
          _createElementVNode("button", {
            class: _normalizeClass(["btn-ultra tips send", { 'loading': _ctx.isSending }]),
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.sendMessage && _ctx.sendMessage(...args)))
          }, [...(_cache[7] || (_cache[7] = [
            _createElementVNode("div", { class: "btn-show" }, [
              _createElementVNode("img", {
                src: "/public/icons/icon-send.svg",
                class: "btn-icon",
                alt: ""
              })
            ], -1),
            _createElementVNode("div", { class: "btn-loading" }, [
              _createElementVNode("div", { class: "loader-dots" })
            ], -1)
          ]))], 2)
        ])
      ])
    ])
  ]))
}